export default __webpack_public_path__ + "static/media/socials.ba47ce03.png";